import React from 'react';
import { Box, BoxProps } from 'rebass';
import { space } from '../../../theme';
import { AnnounceChange } from './AnnounceChange';

export const ErrorMessage: React.FC<
  Omit<BoxProps, 'css'> & {
    errors: any;
    name: string;
    errorName: string;
  }
> = ({ errors, name, errorName, ...props }) => {
  return (
    <AnnounceChange>
      <Box
        as={'span'}
        mt={space.half}
        data-testid={errorName}
        variant="forms.label.errorMessage"
        htmlFor={name}
        {...props}
      >
        {errors && errors[name]}
      </Box>
    </AnnounceChange>
  );
};
